(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wheresell"] && !Shopify.designMode) return;
  try {
    
  // Load Leaflet dynamically
  const leafletCSS = document.createElement('link');
  leafletCSS.rel = 'stylesheet';
  leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  document.head.appendChild(leafletCSS);

  const leafletJS = document.createElement('script');
  leafletJS.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  leafletJS.onload = () => {
    // Check if mobile device
    const isMobile = window.innerWidth <= 768;
    
    // Initialize map with controls on mobile only
    const map = L.map('map', {
      scrollWheelZoom: isMobile,
      zoomControl: isMobile,
      attributionControl: false,
      dragging: isMobile,
      touchZoom: isMobile,
      doubleClickZoom: isMobile,
      boxZoom: false,
      keyboard: false,
      tap: isMobile
    }).setView([30, 10], 2);

    // Available countries with multiple possible ISO codes (as of November 2025)
    const availableCountries = new Set([
      // Asia
      'IDN', 'ID', 'Indonesia',
      'MYS', 'MY', 'Malaysia',
      'THA', 'TH', 'Thailand',
      'VNM', 'VN', 'Vietnam',
      'PHL', 'PH', 'Philippines',
      // Europe
      'GBR', 'GB', 'United Kingdom',
      'FRA', 'FR', 'France',
      'DEU', 'DE', 'Germany',
      'ESP', 'ES', 'Spain',
      'ITA', 'IT', 'Italy',
      'POL', 'PL', 'Poland',
      // North America
      'USA', 'US', 'United States', 'United States of America',
      'CAN', 'CA', 'Canada',
      // Latin America
      'BRA', 'BR', 'Brazil',
      'ARG', 'AR', 'Argentina',
      'COL', 'CO', 'Colombia',
      'CHL', 'CL', 'Chile',
      // Middle East & Africa
      'SAU', 'SA', 'Saudi Arabia',
      'ARE', 'AE', 'UAE', 'United Arab Emirates'
    ]);

    // Upcoming countries (launching soon)
    const upcomingCountries = new Set([
      // Asia
      'IND', 'IN', 'India',
      // Europe
      'HUN', 'HU', 'Hungary',
      // North America
      'MEX', 'MX', 'Mexico',
      // Latin America
      'PER', 'PE', 'Peru',
      // Middle East & Africa
      'EGY', 'EG', 'Egypt',
      'NGA', 'NG', 'Nigeria',
      'KEN', 'KE', 'Kenya'
    ]);

    // Country display names in Czech
    const countryNames = {
      // Asia
      'IDN': 'Indonésie', 'ID': 'Indonésie',
      'MYS': 'Malajsie', 'MY': 'Malajsie',
      'THA': 'Thajsko', 'TH': 'Thajsko',
      'VNM': 'Vietnam', 'VN': 'Vietnam',
      'PHL': 'Filipíny', 'PH': 'Filipíny',
      'IND': 'Indie', 'IN': 'Indie',
      // Europe
      'GBR': 'Velká Británie', 'GB': 'Velká Británie',
      'FRA': 'Francie', 'FR': 'Francie',
      'DEU': 'Německo', 'DE': 'Německo',
      'ESP': 'Španělsko', 'ES': 'Španělsko',
      'ITA': 'Itálie', 'IT': 'Itálie',
      'POL': 'Polsko', 'PL': 'Polsko',
      'HUN': 'Maďarsko', 'HU': 'Maďarsko',
      // North America
      'USA': 'Spojené státy', 'US': 'Spojené státy', 'United States': 'Spojené státy', 'United States of America': 'Spojené státy',
      'CAN': 'Kanada', 'CA': 'Kanada',
      'MEX': 'Mexiko', 'MX': 'Mexiko',
      // Latin America
      'BRA': 'Brazílie', 'BR': 'Brazílie',
      'ARG': 'Argentina', 'AR': 'Argentina',
      'COL': 'Kolumbie', 'CO': 'Kolumbie',
      'CHL': 'Chile', 'CL': 'Chile',
      'PER': 'Peru', 'PE': 'Peru',
      // Middle East & Africa
      'SAU': 'Saúdská Arábie', 'SA': 'Saúdská Arábie',
      'ARE': 'SAE', 'AE': 'SAE',
      'EGY': 'Egypt', 'EG': 'Egypt',
      'NGA': 'Nigérie', 'NG': 'Nigérie',
      'KEN': 'Keňa', 'KE': 'Keňa'
    };

    // Load world countries GeoJSON from a more reliable source
    fetch('https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json')
      .then(response => response.json())
      .then(data => {
        // Style function for countries
        function style(feature) {
          const props = feature.properties;
          const countryCode = props.iso_a3 || props.ISO_A3 || props.iso_a2 || props.ISO_A2 || '';
          const countryName = props.name || props.NAME || props.ADMIN || '';
          
          // Check if country is available or upcoming
          const isAvailable = availableCountries.has(countryCode) || 
                             availableCountries.has(countryName);
          const isUpcoming = upcomingCountries.has(countryCode) || 
                            upcomingCountries.has(countryName);
          
          return {
            fillColor: isAvailable ? '#FF0050' : (isUpcoming ? '#FFA500' : 'rgba(150, 150, 160, 0.4)'),
            weight: 0,
            opacity: 0,
            color: 'transparent',
            fillOpacity: isAvailable ? 0.7 : (isUpcoming ? 0.6 : 0.4)
          };
        }

        // Add countries to map - ALL COUNTRIES, not just available ones
        const geoJsonLayer = L.geoJSON(data, {
          style: style,
          onEachFeature: function(feature, layer) {
            const props = feature.properties;
            const countryCode = props.iso_a3 || props.ISO_A3 || props.iso_a2 || props.ISO_A2 || '';
            const countryName = props.name || props.NAME || props.ADMIN || '';
            const isAvailable = availableCountries.has(countryCode) || 
                               availableCountries.has(countryName);
            const isUpcoming = upcomingCountries.has(countryCode) || 
                              upcomingCountries.has(countryName);
            
            const displayName = countryNames[countryCode] || countryNames[countryName] || countryName;
            
            // Add hover and popup for AVAILABLE and UPCOMING countries
            if (isAvailable || isUpcoming) {
              layer.on({
                mouseover: function(e) {
                  const layer = e.target;
                  layer.setStyle({
                    fillColor: '#25F4EE',
                    fillOpacity: 0.9,
                    weight: 2,
                    color: '#FFFFFF',
                    opacity: 1
                  });
                  layer.bringToFront();
                },
                mouseout: function(e) {
                  geoJsonLayer.resetStyle(e.target);
                },
                click: function() {
                  const popupContent = isAvailable ? 
                    `<div style="text-align: center;">
                      <div style="font-size: 18px; font-weight: 800; background: linear-gradient(135deg, #FF0050, #25F4EE); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin-bottom: 4px;">
                        ${displayName}
                      </div>
                      <div style="font-size: 13px; color: rgba(255, 255, 255, 0.7);">
                        ✓ TikTok Shop dostupný
                      </div>
                    </div>` :
                    `<div style="text-align: center;">
                      <div style="font-size: 18px; font-weight: 800; background: linear-gradient(135deg, #FFA500, #FFD700); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin-bottom: 4px;">
                        ${displayName}
                      </div>
                      <div style="font-size: 13px; color: rgba(255, 165, 0, 0.9);">
                        ⏳ Brzy k dispozici
                      </div>
                    </div>`;
                  
                  layer.bindPopup(popupContent).openPopup();
                }
              });
            }
          }
        }).addTo(map);
      })
      .catch(error => {
        console.error('Error loading GeoJSON:', error);
        // Fallback: show text message
        document.getElementById('map').innerHTML = `
          <div style="display: flex; align-items: center; justify-content: center; height: 100%; color: white; text-align: center; padding: 20px;">
            <div>
              <h3 style="margin-bottom: 16px;">TikTok Shop je dostupný v:</h3>
              <p style="font-size: 16px; line-height: 1.8;">
                🌏 Asie: Indonésie, Malajsie, Thajsko, Vietnam, Filipíny<br>
                🇪🇺 Evropa: Velká Británie, Francie, Německo, Španělsko, Polsko<br>
                🇺🇸 Severní Amerika: Spojené státy, Kanada<br>
                🌎 Latinská Amerika: Brazílie, Argentina, Kolumbie, Chile<br>
                🌍 Blízký východ a Afrika: Saúdská Arábie, SAE
              </p>
              <h4 style="margin-top: 20px; margin-bottom: 12px; color: #FFA500;">⏳ Brzy k dispozici:</h4>
              <p style="font-size: 14px; line-height: 1.6; color: rgba(255, 165, 0, 0.9);">
                Indie, Maďarsko, Mexiko, Peru, Egypt, Nigérie, Keňa
              </p>
            </div>
          </div>
        `;
      });
  };
  document.body.appendChild(leafletJS);

  } catch(e) { console.error(e); }
})();
})();
